export class FeatureNames {
  static EventTracking: string = 'eventtracking';
}
